<template>
  <div class="gray-back page-ability-success">
    <div class="order-success">
      <div class="icon"/>
      <div class="title">申报成功</div>
      <p class="sub">您已完成能力测试报名，如需修改请联系工作人员。</p>
    </div>

    <van-cell-group v-if="loaded">
      <van-cell title="单位" :value="detail.danwei || '—'" input-align="right"/>
      <van-cell title="联系人" :value="detail.ldname || '—'" input-align="right"/>
      <van-cell title="联系电话" :value="detail.phone || '—'" input-align="right"/>
      <van-cell title="年份" :value="detail.saiji_text || '—'" input-align="right"/>
      <van-cell title="场次" :value="detail.saiqu_text || '—'" input-align="right"/>
    </van-cell-group>

    <van-divider v-if="loaded && members.length">报名人员</van-divider>
    <van-cell-group v-if="members.length">
      <van-cell
          v-for="(m, index) in members"
          :key="index"
          :title="'人员' + (index + 1)"
          :value="m.name || '—'"
          input-align="right"
      >
        <template #label>
          <span class="cell-label">{{ m.num }} · {{ m.project }}-{{ m.grade }}</span>
        </template>
      </van-cell>
    </van-cell-group>

    <div class="savebtn">
      <van-button
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          style="width: 3rem"
          size="normal"
          round
          @click="backList"
      >返回列表
      </van-button>
      <van-button
          style="width: 3rem"
          size="normal"
          round
          @click="toMember"
      >人员服务
      </van-button>
    </div>
  </div>
</template>

<style scoped>
.page-ability-success {
  min-height: 100vh;
  padding: 0.2rem 0 5rem;
  box-sizing: border-box;
}

.order-success {
  text-align: center;
  margin: 0.4rem 0 0.3rem;
}

.order-success .icon {
  background: url(../../../assets/images/icon-order-done.png);
  background-size: 100%;
  width: 75px;
  height: 75px;
  margin: 0.2rem auto;
}

.order-success .title {
  font-size: 18px;
  font-weight: bold;
  color: #000;
}

.order-success .sub {
  font-size: 12px;
  color: #999;
  margin: 0.2rem 0.4rem 0;
  line-height: 1.5;
}

.cell-label {
  font-size: 12px;
  color: #999;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}
</style>

<script>
import Vue from 'vue';
import { Cell, CellGroup, Toast, Button, Divider } from 'vant';

Vue.use(Cell).use(CellGroup).use(Toast).use(Button).use(Divider);

export default {
  name: 'AbilityApplySuccess',
  data() {
    return {
      baomingId: 0,
      loaded: false,
      detail: {},
      members: [],
    };
  },
  mounted() {
    document.title = '申报成功';
    const qid = this.$route.query.id;
    this.baomingId = qid ? parseInt(qid, 10) : 0;
    if (isNaN(this.baomingId) || this.baomingId <= 0) {
      Toast.fail('缺少报名编号');
      return;
    }
    this.fetchDetail();
  },
  methods: {
    fetchDetail() {
      const that = this;
      that.$api.get('/api/ability/step1Detail', { id: that.baomingId }, (res) => {
        that.detail = res.data || {};
        that.members = Array.isArray(that.detail.yundongyuan) ? that.detail.yundongyuan : [];
        that.loaded = true;
      }, (res) => {
        Toast.fail(res.msg || '加载失败');
      });
    },
    backList() {
      rbLink({ name: 'AbilityApplyList' }, 'replace');
    },
    toMember() {
      rbLink({
        name: 'AbilityApplyMemberService',
        query: { id: this.baomingId },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// AbilityApplySuccess.vue?dec542c4